import BusinessIcon from '@mui/icons-material/Business';
import { LeadCompanyList } from './LeadCompanyList';
import { LeadCompanyShow } from './LeadCompanyShow';

export default {
  list: LeadCompanyList,
  show: LeadCompanyShow,
  icon: BusinessIcon,
};
